<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="page-header">
  <div>
    <h1 class="title">
      <i class="pi pi-server"></i>
      {{ 'SYSTEMS.TITLE' | translate }}
    </h1>
    <p class="sub">{{ 'SYSTEMS.SUBTITLE' | translate }}</p>
  </div>
  <div class="tools">
    <button
      pButton
      icon="pi pi-plus"
      label="نظام جديد"
      (click)="openNew()"
    ></button>
  </div>
</div>

<p-table
  [value]="rows"
  styleClass="systems-table"
  [tableStyle]="{ 'min-width': '70rem' }"
  [loading]="loading"
  [paginator]="true"
  [rows]="10"
  [rowsPerPageOptions]="[10, 25, 50, 100]"
  [responsiveLayout]="'stack'"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 80px" class="text-center">
        <i class="pi pi-hashtag"></i>
      </th>
      <th>
        <i class="pi pi-key"></i>
        {{ 'SYSTEMS.KEY' | translate }}
      </th>
      <th>
        <i class="pi pi-tag"></i>
        الاسم الظاهر
      </th>
      <th style="width: 120px" class="text-center">
        <i class="pi pi-circle-fill"></i>
        الحالة
      </th>
      <th style="width: 140px" class="text-end">إجراءات</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-r>
    <tr>
      <td class="text-center">
        <span class="id-badge">{{ r.id || '—' }}</span>
      </td>
      <td>
        <div class="key-cell">
          <code class="key-code">{{ r.key }}</code>
        </div>
      </td>
      <td>
        <div class="display-name-cell">
          <i class="pi pi-desktop system-icon"></i>
          <span class="name-text">{{ r.displayName }}</span>
        </div>
      </td>
      <td class="text-center">
        <span
          class="chip"
          [class.chip--success]="r.isActive !== false"
          [class.chip--danger]="r.isActive === false"
        >
          <i
            class="pi"
            [class.pi-check-circle]="r.isActive !== false"
            [class.pi-times-circle]="r.isActive === false"
          ></i>
          {{ r.isActive !== false ? 'نشط' : 'غير نشط' }}
        </span>
      </td>
      <td class="text-end">
        <button
          pButton
          icon="pi pi-pencil"
          class="p-button-text"
          pTooltip="تعديل"
          (click)="openEdit(r)"
        ></button>
        <button
          pButton
          icon="pi pi-trash"
          class="p-button-text p-button-danger"
          pTooltip="حذف"
          (click)="remove(r)"
        ></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5" class="empty-state">
        <div class="empty-content">
          <i class="pi pi-inbox"></i>
          <p>{{ 'SYSTEMS.NO_SYSTEMS' | translate }}</p>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog [(visible)]="show" [modal]="true" [style]="{ width: '520px' }">
  <ng-template pTemplate="header">
    {{ editId ? 'تعديل نظام' : 'نظام جديد' }}
  </ng-template>

  <div class="p-fluid form" style="display: grid; gap: 1rem;">
    <div class="field">
      <label>المعرّف (Key) <span class="required">*</span></label>
      <input pInputText [(ngModel)]="form.key" placeholder="مثل: lab, hr, insurance" />
      <small class="p-text-secondary">مفتاح فريد بدون مسافات (يستخدم في الصلاحيات)</small>
    </div>

    <div class="field">
      <label>الاسم الظاهر <span class="required">*</span></label>
      <input pInputText [(ngModel)]="form.displayName" placeholder="اسم النظام كما يظهر للمستخدم" />
    </div>

    <div class="field" style="display: flex; align-items: center; gap: 0.75rem;">
      <p-inputSwitch [(ngModel)]="form.isActive"></p-inputSwitch>
      <label>نشط</label>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      label="إلغاء"
      class="p-button-secondary"
      [disabled]="saving"
      (click)="show = false"
    ></button>
    <button
      pButton
      label="حفظ"
      icon="pi pi-save"
      [disabled]="saving"
      (click)="save()"
    ></button>
  </ng-template>
</p-dialog>
